// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"_2N5QoL0Ns4x96ZzjWscfYz","modalDialog":"_1q3jwkyjiabK82lHvXHk63","btn-cancel":"_3m0NIZsZkrDGerUD6X2AUi","btn-save":"_1U5M6iY8coB79BrqCqUHDl"};